import React, { CSSProperties } from 'react';
import { IDropdownMenuItem, IFormField } from '@vivli/shared/infrastructure/interface';
import { BaseControlledFormFieldComponent } from './base-controlled-form-field.component';
import { AdvancedSelectInputFieldComponent } from '../input/advanced-select-input-field.component';

/* Type-ahead replacement for DropdownFormFieldComponent. Same props, same stored value, so a
 * call site swaps by renaming the component. The searchable control is react-select; the
 * option and selected-value test ids are preserved inside AdvancedSelectComponent so the
 * Selenium suite keeps working. (DEV-961) */
interface AdvancedSelectFormFieldComponentProps extends IFormField {
    selectText?: string;
    items: IDropdownMenuItem[];
    name: string;
    objectKey?: string;
    valueKey?: string;
    isSearchable?: boolean;
    isClearable?: true;
    menuPosition?: 'fixed' | 'absolute';
    menuPlacement?: 'auto' | 'bottom' | 'top';
    targetStyle?: CSSProperties;
    //omit for react-select's own sizing; pass a number where a row needs a shorter control
    controlHeight?: number;
    sort?: 'asc' | 'desc';
    widerHint?: boolean;
}

export const AdvancedSelectFormFieldComponent = (props: AdvancedSelectFormFieldComponentProps) => {
    return (
        <BaseControlledFormFieldComponent {...props}>
            <AdvancedSelectInputFieldComponent {...props} />
        </BaseControlledFormFieldComponent>
    );
};
